import { Turnstile } from "@marsidev/react-turnstile";

import { getTurnstileSiteKey } from "~/utils/turnstile";

export function TurnstileField({
  onToken,
}: {
  onToken: (token: string | null) => void;
}) {
  const siteKey = getTurnstileSiteKey();
  if (!siteKey) return null;
  return (
    <Turnstile
      siteKey={siteKey}
      options={{ action: "turnstile-spin-v2" }}
      onSuccess={onToken}
      onExpire={() => onToken(null)}
      onError={() => onToken(null)}
    />
  );
}
